"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    durationPlugin: ()=>durationPlugin
});
function durationPlugin(upload) {
    const durationMap = new WeakMap();
    return {
        request: [
            (config)=>{
                durationMap.set(config, Date.now());
                return config;
            }
        ],
        response: [
            (response)=>{
                const start = durationMap.get(response.config);
                if (start) {
                    const duration = Date.now() - start;
                    upload(response.config.url, duration);
                    console.log('TODO:', duration);
                }
                return response;
            }
        ]
    };
}
exports.durationPlugin = __webpack_exports__.durationPlugin;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "durationPlugin"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
